import YoutubeDashboardView from "src/sections/dashboards/platforms/youtube/youtube-dashboard-view";

const YoutubeMainDashboardPage = () => <YoutubeDashboardView type="main" />;

export default YoutubeMainDashboardPage;
